export default "__VITE_ASSET__BOdlFNx7__"